import React, { useState, useRef, useEffect, createContext } from "react";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { mapStyles } from "../../../utils/data/mapStyle";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import * as Icon1 from "../../../assets/iconsMapPNG/incidents/priority_1/_index";
import * as Icon2 from "../../../assets/iconsMapPNG/incidents/priority_2/_index";
import { IconsSize } from "../../../styles/Theme/IconsSize";
import { BusDelayed, BusPosition } from "../../../assets/iconsMapPNG/_index";
import Theme from '../../../styles/Theme/Theme';
import { Text } from '../Atomics/Text'
import styled from "styled-components";

const isVideowall = window.matchMedia(Theme.devices.videowall).matches;
const windowWidth = window.innerWidth;
//Tootlip styles
const marginTooltipWrapper = isVideowall ? Theme.spacing.xl : Theme.spacing.md;
const fontSizeTooltipTitle = isVideowall ? Theme.typography.fontSize['text_xxl_videowall'] : Theme.typography.fontSize['text_xxl_desktop'];
const fontWeightTooltipTitle = Theme.typography.weight.medium;
const fontSizeTooltipText = isVideowall ? Theme.typography.fontSize['text_lg_videowall'] : Theme.typography.fontSize['text_lg_desktop'];

//CREATE MAP
const MyMap = (props) => {
    let [map, setMap] = useState();
    const ref = useRef();

    const data = props?.config?.configurations;
    const incidents = props?.config?.incidents ?? [];
    const gtfsRealtime = props?.config?.realtimebus ?? [];

    const cascaisBounds = {
        north: 38.7900,
        south: 38.6000,
        west: -9.6000,
        east: -9.2000,
    };

    const mapConfig = {
        mapId: data.mapId ?? null,
        center: { lat: data.lat ?? 38.715357, lng: data.lng ?? -9.360761 },
        zoom: data.zoom ?? 13,
        disableDefaultUI: data.disableDefaultUI ?? true,
        restriction: {
            latLngBounds: cascaisBounds,
            strictBounds: false,
        },
        heading: data.heading ?? 0,
        tilt: data.tilt ?? 60,
        styles: !data.mapId ? mapStyles[data.styles] ?? "default" : null,
    }

    //Layers
    const showTransit = data.showTransit ?? false;
    const showTraffic = data.showTraffic ?? false;
    const showBusRoutes = data.showBusRoutes ?? false;
    const showIncidents = data.showIncidents ?? false;
    const showIncidentsTooltips = data.showIncidentsTooltips ?? false;
    const showRealTimeVehicle = data.showRealTimeVehicle ?? false;
    const showRealTimeVehicleTooltip = data.showRealTimeVehicleTooltip ?? false;

    useEffect(() => {
        if (ref.current && !map) {

            map = new window.google.maps.Map(ref.current, mapConfig);

            if (showTraffic) {
                updateTrafficOnMap(map, null, 1);
            }

            // if (showTransit) {
            //     const transitLayer = new window.google.maps.TransitLayer();
            //     transitLayer.setMap(map);
            //     setInterval(() => {
            //         const transitLayer2 = new window.google.maps.TransitLayer();
            //         transitLayer.setMap(null);
            //         transitLayer2.setMap(null);
            //         transitLayer2.setMap(map);
            //     }, 60000);
            // }

            if (showIncidents) {
                incidentsLayer(incidents, map, showIncidentsTooltips)
            }

            if (showBusRoutes) {

            }

            if (showRealTimeVehicle) {
                realTimeVehicle(gtfsRealtime, map, showRealTimeVehicleTooltip);
            }

        }
    }, [ref, map]);

    useEffect(() => {
        if (showIncidents) {
            setMap(null);
            incidentsLayer(incidents, map, showIncidentsTooltips);
            setMap(map);
        }
    }, [incidents])

    useEffect(() => {
        if (showRealTimeVehicle) {
            setMap(null);
            realTimeVehicle(gtfsRealtime, map, showRealTimeVehicleTooltip);
            setMap(map);
        }
    }, [gtfsRealtime])

    return <div ref={ref} id="map" style={{ overflow: "visible!important", height: "100%", borderRadius: 'inherit' }}></div>
}

function updateTrafficOnMap(map, trafficLayer, on) {
    if (on == 0) {
        trafficLayer.setMap(null);
        setTimeout(function () { updateTrafficOnMap(map, null, 1) }, 1)
    }
    if (on == 1) {
        var trafficLayer2 = new window.google.maps.TrafficLayer();
        trafficLayer2.setMap(map);
        // after 300ms (or 5 minutes) update the traffic map
        setTimeout(function () { updateTrafficOnMap(map, trafficLayer2, 0) }, 300000)
    }
}

//Incidents Layer
let markers = [];
const incidentsLayer = (incidents, map, showIncidentsTooltips) => {
    const highPriority = [];
    const mediumPriority = [];

    markers.map(e => {
        window.google.maps.event.clearListeners(e, 'click');
        window.google.maps.event.clearListeners(e, 'closeclick');
        e.setMap(null);
    })

    markers = [];

    if (incidents.length) {
        incidents.map((e) => {
            const priority = e.urgency.split(' - ');
            if (priority[0] == '1') {
                highPriority.push(e);
            } else if (priority[0] == '2') {
                mediumPriority.push(e)
            }
        })

        incidents.map((e) => {
            const latLng = { lat: parseFloat(e.latitude), lng: parseFloat(e.longitude) };

            const iconFamily = e.service_family.split('.').pop();
            const iconPriority = e.priority.split(' - ');
            const iconImage = iconFamily.toLowerCase().split(' ').join('_') + '_' + iconPriority[0]

            const icon1 = Icon1[iconImage] ?? Icon1['default_1'];
            const icon2 = Icon2[iconImage] ?? Icon2['default_2'];
            const scaledSize = !isVideowall ? new window.google.maps.Size(25, 25) : new window.google.maps.Size(40, 40);
            let iconToShow = {
                url: iconPriority[0] == '1' ? icon1 : icon2,
                scaledSize: scaledSize
            }

            if (iconPriority[0] == '1' || iconPriority[0] == '2') {

                const marker = new window.google.maps.Marker({
                    position: latLng,
                    map,
                    title: e.affected_user ?? null,
                    icon: iconToShow,

                });

                let contentText = '<div style="margin: ' + marginTooltipWrapper + '"><p style="font-size: ' + fontSizeTooltipText + '; margin-top:0" >' + e.reference_number + '</p><p  style="font-size: 0.325vw; margin-bottom:0">' + e.city_service_name + '</p></div>';
                const infoWindow = new window.google.maps.InfoWindow({
                    content: contentText,
                    position: latLng,
                    maxWidth: 1000
                });
                marker.addListener("click", () => {
                    infoWindow.open({
                        map: map,
                        anchor: marker,
                        shouldFocus: true
                    });

                });

                infoWindow.addListener('closeclick', () => { })

                marker.setClickable(showIncidentsTooltips)

                markers.push(marker);
            }

        })


    }

    let renderer = {
        gridSize: 60, // Adjust grid size as desired
        minimumClusterSize: 20, // Adjust minimum cluster size as desired
        maxZoom: 15, // Adjust maximum zoom level as desired
        render({ count, position }, stats) {
            const svg = window.btoa(`
            <svg width="64" height="64" viewBox="0 0 152 152" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="4" width="148" height="148" rx="50%" fill="#0076A8"/>
            </svg>`);
            const scaledSize = !isVideowall ? new window.google.maps.Size(30, 30) : new window.google.maps.Size(60, 60);
            return new window.google.maps.Marker({
                position,
                icon: {
                    url: `data:image/svg+xml;base64,${svg}`,
                    scaledSize: scaledSize
                },
                title: `Cluster of ${count} markers`,
                zIndex: Number(window.google.maps.Marker.MAX_ZINDEX) + count,
                label: {
                    text: String(count),
                    color: "rgba(255,255,255,0.9)",
                    fontSize: fontSizeTooltipText,
                },
            });
        }
    }

    new MarkerClusterer({ markers, map, renderer });

    markers.map(e => {
        e.setMap(map);
    })

}

let busMarkers = [];
//Real time vehicle
const realTimeVehicle = (gtfsRealtime, map, showRealTimeVehicleTooltip) => {

    busMarkers.map(e => {
        window.google.maps.event.clearListeners(e, 'click');
        window.google.maps.event.clearListeners(e, 'closeclick');
        e.setMap(null);
    })

    busMarkers = [];

    let identities = gtfsRealtime?.entity;

    if(identities){
        identities.map((e) => {

        const isIncident = false;

        let newLat = e.vehicle.position.latitude;
        let newLng = e.vehicle.position.longitude;

        const latLng = { lat: parseFloat(newLat), lng: parseFloat(newLng) };

        const scaledSize = !isVideowall ? new window.google.maps.Size(20, 20) : new window.google.maps.Size(60, 60);

        let labelId = e?.id.split(':');
        let labelText = e?.vehicle?.trip?.routeId ? e?.vehicle?.trip?.routeId + ': ' + labelId[0] : labelId[0];
        let textWidth = labelText.toString().length;
        let getFont = Theme.typography.fontSize[fontSizeTooltipText];
        const numericValue = parseFloat(fontSizeTooltipText.match(/[\d\.]+/)[0]);
        let fontSizeLabel = numericValue * windowWidth / 100
        let widthLabel = textWidth * fontSizeLabel * 0.7;
        let heightLabel = fontSizeLabel * 1.5;

        let iconToShow;
        if (isIncident) {
            iconToShow = {
                url: Icon1['transportation_1'],
                scaledSize: !isVideowall ? new window.google.maps.Size(20, 20) : new window.google.maps.Size(20, 20)
            }
        } else if (e?.vehicle?.trip) {
            iconToShow = {
                url: BusPosition,
                scaledSize: !isVideowall ? new window.google.maps.Size(20, 20) : new window.google.maps.Size(20, 20)
            }
        } else {
            iconToShow = {
                url: BusDelayed,
                scaledSize: !isVideowall ? new window.google.maps.Size(20, 20) : new window.google.maps.Size(20, 20)
            }
        }


        let contentText = '<div style="margin: ' + marginTooltipWrapper + '"><p style="font-size: ' + fontSizeTooltipTitle + '; font-weight: ' + fontWeightTooltipTitle + '; margin:0" >' + e?.vehicle?.trip?.routeId + '</p></div>';

        const marker = new window.google.maps.Marker({
            position: latLng,
            map,
            icon: iconToShow,
        });

        let vehicle;

        // if (isIncident) {

            // let contentText = '<div style="margin: ' + marginTooltipWrapper + '"><p style="font-size: ' + fontSizeTooltipTitle + '; font-weight: ' + fontWeightTooltipTitle + '; margin-top:0" >' + e?.vehicle?.trip?.routeId + '</p><p  style="font-size: ' + fontSizeTooltipText + '; margin-bottom:0">' + e?.id + '</p></div>';

            const infoWindow = new window.google.maps.InfoWindow({
                content: contentText,
                position: latLng,
                maxWidth: 1000
            });

            marker.addListener("click", () => {
                console.log('Deloitte');
                infoWindow.open({
                    map: map,
                    anchor: marker,
                    shouldFocus: false
                });
            });

            infoWindow.addListener('closeclick', () => { })

            marker.setClickable(showRealTimeVehicleTooltip)

        // }

        busMarkers.push(marker);

        })
    }

    busMarkers.map(e => {
        e.setMap(map);
    })

}

//RENDER MAP
const GoogleMap = (props) => {
    return (
        <Wrapper apiKey="AIzaSyCNJX-A4a4TpN8tvWzszCUOQN-5fN9x4nU" ><MyMap config={props} /></Wrapper>
    )
}

export { GoogleMap }